import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {MatSelectModule} from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';

//// FUSE
import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseDemoModule } from '@fuse/components/demo/demo.module';
// SWEETALERT
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

/// COMPONENTES
import { WizardN35Component } from './wizard-n35.component';
//import { BlankComponent } from '../pagina/blank/blank.component';
import { TranslateModule } from '@ngx-translate/core';



//DRAG

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';


import { GeneralinformationComponent } from '../pagina/certificarN35/generalinformation/generalinformation.component';
import { DrawComponent } from '../pagina/certificarN35/draw/draw.component';
import { BlogComponent } from '../pagina/certificarN35/blog/blog.component';
import { WorkflowComponent} from '../pagina/certificarN35/workflow/workflow.component';
import { SpaceconfigurationComponent } from '../pagina/certificarN35/spaceconfiguration/spaceconfiguration.component';
import {TasklistComponent} from '../pagina/certificarN35/tasklist/tasklist.component';

import { Norm35DocumentComponent } from '../pagina/certificarN35/norm35-document/norm35-document.component';
import { Norm35DocumentTableComponent } from '../pagina/certificarN35/norm35-document/norm35-document-table/norm35-document-table.component';

import { Norm35ObjectComponent } from '../pagina/certificarN35/norm35-object/norm35-object.component';
import { Norm35Step7Component } from '../pagina/certificarN35/norm35-step7/norm35-step7.component';
import { Norm35Step8Component } from '../pagina/certificarN35/norm35-step8/norm35-step8.component';
import { Norm35Step9Component } from '../pagina/certificarN35/norm35-step9/norm35-step9.component';
import { Norm35Step10Component } from '../pagina/certificarN35/norm35-step10/norm35-step10.component';
import {TablesStepsComponent } from '../pagina/certificarN35/draw/tables-steps/tables-steps.component';
import { Step10TablesComponent } from '../pagina/certificarN35/norm35-step10/step10-tables/step10-tables.component';
import { Step9TablesComponent } from '../pagina/certificarN35/norm35-step9/step9-tables/step9-tables.component';
import {PoliticaComponent} from '../pagina/certificarN35/norm35-document/politica/politica.component';
import { Step8DataComponent } from '../pagina/certificarN35/norm35-step8/step8-data/step8-data.component';
import { Step8TableComponent } from '../pagina/certificarN35/norm35-step8/step8-table/step8-table.component';

import { Step7TableComponent } from '../pagina/certificarN35/norm35-step7/step7-table/step7-table.component';
import { Step7DataComponent } from '../pagina/certificarN35/norm35-step7/step7-data/step7-data.component';
//import { Step6TableComponent } from '../pagina/certificarN35/workflow/step6-table/step6-table.component';

import {Step6TableComponent} from '../pagina/certificarN35/workflow/step6-table/step6-table.component';
import {Step5DataComponent} from '../pagina/certificarN35/draw/step5-data/step5-data.component';
import { EditarNorm35Component } from '../pagina/certificarN35/editar-norm35/editar-norm35.component';
import {AspectsComponent} from '../pagina/certificarN35/norm35-document/aspects/aspects.component';
import {ListComponent} from '../pagina/certificarN35/norm35-document/list/list.component';
import {ReferenciaComponent} from '../pagina/certificarN35/referencia/referencia.component';
import {Guia1Component} from '../pagina/certificarN35/norm35-document/guia1/guia1.component';
import {Guia4Component} from '../pagina/certificarN35/norm35-document/guia4/guia4.component';
import {SecondnavbarComponent} from '../pagina/certificarN35/secondnavbar/secondnavbar.component';
import { TaskfilesComponent } from '../pagina/certificarN35/taskfiles/taskfiles.component';

import {ColaboradoresComponent } from '../pagina/certificarN35/colaboradores/colaboradores.component';
import {DialogVideo} from '../pagina/certificarN35/colaboradores/colaboradores.component';
import {VideoModal} from '../pagina/certificarN35/colaboradores/dialog.component';
import {DialogTableVideo} from '../pagina/certificarN35/draw/tables-steps/tables-steps.component';
import {ExpedienteComponent} from '../pagina/certificarN35/expediente/expediente.component';
import {ExpedienteModule} from '../pagina/certificarN35/expediente/expediente.module';
import { InformacionCtComponent } from '../pagina/certificarN35/informacion-ct/informacion-ct.component';
import {TimelineComponent} from '../pagina/certificarN35/timeline/timeline.component';
import {MedicoDialog} from '../pagina/certificarN35/expediente/expediente.component';
const rutas: Routes = [
  {
      path     : 'NOM35/wizard',
      component: WizardN35Component,
      children: [
          { path: '', redirectTo: 'lista-archivos', pathMatch: 'full'  },
          // Temporales

          {path: 'editar-datos-norm35', component: EditarNorm35Component, canActivate: [AuthGuard]},
          { path: 'editar-datos-norm35-step5', component: EditarNorm35Component, data: {id:'5.1 Política de prevención de riesgos psicosociales  5.1 a) La prevención de los factores de riesgo psicosocial  5.1 b) La prevención de la violencia labora5.1 c) La promoción de un entorno organizacional favorable'}, canActivate: [AuthGuard]},
          { path: 'obj', component: GeneralinformationComponent, data: {id:'1'}, canActivate: [AuthGuard]},
          { path: 'definiciones', component: BlogComponent, data: {id:'2'}, canActivate: [AuthGuard]},
          { path: 'work-flow', component: WorkflowComponent, canActivate: [AuthGuard]},
          { path: 'to-do-task', component: TasklistComponent, canActivate: [AuthGuard]},
          { path: 'politicas-ejemplo', component: PoliticaComponent, canActivate: [AuthGuard]},
          { path: 'aspectos-verificar', component: AspectsComponent, canActivate: [AuthGuard]},
          { path: 'referencia', component: ReferenciaComponent, canActivate: [AuthGuard]},
          { path: 'lista-archivos',component: TaskfilesComponent, canActivate: [AuthGuard]},
          { path : 'time-line', component: TimelineComponent, canActivate: [AuthGuard]},
          { path: 'listas', component: SecondnavbarComponent, canActivate: [AuthGuard]},
          { path: 'expendientes',component:ExpedienteComponent, canActivate: [AuthGuard]},

          { path: 'obligaciones', component: Norm35Step9Component, data: {id:'9'}, canActivate: [AuthGuard]},
          { path: 'aplicacion', component: Norm35ObjectComponent,data: {id:'12'}, canActivate: [AuthGuard]},
          { path: 'documentos-soporte', component: Norm35DocumentComponent, data: {id:'11'}, canActivate: [AuthGuard]},
          { path: 'guia-II', component: Norm35DocumentTableComponent, data: {id:'111'}, canActivate: [AuthGuard]},
          { path: 'guia-III', component: Norm35DocumentTableComponent, data: {id: '112'}, canActivate: [AuthGuard]},
          { path: 'guia-I', component: Guia1Component, data: {id: '113'}, canActivate: [AuthGuard]},
          // NUEVAS RUTAS PRUEBAS
          {path: 'guia-V',component: Guia4Component, canActivate: [AuthGuard]},
          // NUM1
          {path: 'politica' , component: TablesStepsComponent, data : {id : '52'},canActivate: [AuthGuard] },
          // NUM2
          {path: 'encuesta-16-50' , component: TablesStepsComponent, data : {id : '53'},canActivate: [AuthGuard] },
          // NUM3
          {path: 'encuesta-50-mas' , component: TablesStepsComponent, data : {id : '54'},canActivate: [AuthGuard] },
          // NUM4
          {path: 'medidas-preventivas&control ' , component: TablesStepsComponent, data : {id : '55'},canActivate: [AuthGuard] },
          // NUM5
          {path: 'quejas-denuncias' , component: TablesStepsComponent, data : {id : '56'},canActivate: [AuthGuard] },
          // NUM6
          {path: 'plan-acciones',component: TablesStepsComponent, data : {id:'51a'}, canActivate: [AuthGuard]},
          // NUM7
          {path: 'kpis',component: TablesStepsComponent, data : {id:'51b'}, canActivate: [AuthGuard]},
          // NUM8
          {path: 'encuesta-eventos-traumáticos',component: TablesStepsComponent, data : {id:'51c'}, canActivate: [AuthGuard]},
          // NUM9
          {path: 'exámenes-médicos',component: TablesStepsComponent, data : {id:'57a'}, canActivate: [AuthGuard]},
          // NUM10
          {path: 'alteraciones-salud',component: TablesStepsComponent, data : {id:'57b'}, canActivate: [AuthGuard]},

          {path: 'obligaciones-colaboradores',component: ColaboradoresComponent, canActivate:[AuthGuard]},
          //////////////////////////
          {path: 'registros',component: TablesStepsComponent, data : {id:'57c'}, canActivate: [AuthGuard]},

          {path: 'inforamcionCT', component: InformacionCtComponent, canActivate:[AuthGuard]},

          {path: 'step5', component: DrawComponent, data : {id:'5'}, canActivate: [AuthGuard]} ,
          {path : 'step5-sub', component: TablesStepsComponent,data : {id:'51'}, canActivate: [AuthGuard],  },
          {path: 'step5-sub1',component: Step5DataComponent, data : {id:'51'}, canActivate: [AuthGuard]},
          {path: 'step5-sub7',component: Step5DataComponent, data : {id:'57'}, canActivate: [AuthGuard]},
          {path: 'step5-sub7-d)',component: TablesStepsComponent, data : {id:'57d'}, canActivate: [AuthGuard]},
          {path: 'step5-sub7-e)',component: TablesStepsComponent, data : {id:'57e'}, canActivate: [AuthGuard]},
          {path: 'step5-sub7-f)',component: TablesStepsComponent, data : {id:'57f'}, canActivate: [AuthGuard]},
          {path: 'step5-sub8',component: Step5DataComponent, data : {id:'58'}, canActivate: [AuthGuard]},
          {path: 'step5-sub8-a)',component: TablesStepsComponent, data : {id:'58a'}, canActivate: [AuthGuard]},
          {path: 'step5-sub8-b)',component: TablesStepsComponent, data : {id:'58b'}, canActivate: [AuthGuard]},
          {path: 'step5-sub8-c)',component: TablesStepsComponent, data : {id:'58c'}, canActivate: [AuthGuard]},


          {path: 'definiciones-tab', component: WorkflowComponent, data: {id:'6'}, canActivate: [AuthGuard]},
          {path: 'step6-sub1', component: TablesStepsComponent, data: {id:'61'}, canActivate:[AuthGuard]},
          {path: 'step6-sub2', component: TablesStepsComponent, data: {id:'62'}, canActivate:[AuthGuard]},
          {path: 'step6-sub3', component: TablesStepsComponent, data: {id:'63'}, canActivate:[AuthGuard]},
          {path: 'step6-sub4', component: TablesStepsComponent, data: {id:'64'}, canActivate:[AuthGuard]},
          {path: 'step6-sub5', component: TablesStepsComponent, data: {id:'65'}, canActivate:[AuthGuard]},
          {path: 'step6-sub6', component: TablesStepsComponent, data: {id:'66'}, canActivate:[AuthGuard]},
          {path: 'step6-sub7', component: TablesStepsComponent, data: {id:'67'}, canActivate:[AuthGuard]},



          { path: 'step7', component: Norm35Step7Component, data: {id:'7'}, canActivate: [AuthGuard]},
          {path : 'step7-sub1', component: Step7DataComponent, data : {id:'71'},canActivate: [AuthGuard] },
          {path : 'step7-sub2', component: Step7DataComponent, data : {id:'72'},canActivate: [AuthGuard] },
          {path : 'step7-sub3', component: Step7DataComponent, data : {id:'73'},canActivate: [AuthGuard] },

          {path : 'step7-sub3-a)', component: Step7DataComponent, data : {id:'73a'},canActivate: [AuthGuard]},
          {path : 'step7-sub3-b)', component: Step7DataComponent, data : {id:'73b'},canActivate: [AuthGuard]},
          {path : 'step7-sub3-c)', component: Step7DataComponent, data : {id:'73c'},canActivate: [AuthGuard]},
          {path : 'step7-sub3-d)', component: Step7DataComponent, data : {id:'73d'},canActivate: [AuthGuard]},
          {path : 'step7-sub3-e)', component: Step7DataComponent, data : {id:'73e'},canActivate: [AuthGuard]},
          {path : 'step7-sub3-f)', component: Step7DataComponent, data : {id:'73f'},canActivate: [AuthGuard]},


          {path : 'step7-sub4', component: Step7DataComponent, data : {id:'74'},canActivate: [AuthGuard] },
          {path : 'step7-sub1-a)', component: TablesStepsComponent, data : {id:'71a'},canActivate: [AuthGuard] },
          {path : 'step7-sub1-b)', component: TablesStepsComponent, data : {id:'71b'},canActivate: [AuthGuard] },

          {path : 'step7-sub2-a)', component: TablesStepsComponent, data: {id:'72a'},canActivate:[AuthGuard]},
          {path : 'step7-sub2-b)', component: TablesStepsComponent, data: {id:'72b'},canActivate:[AuthGuard]},
          {path : 'step7-sub2-c)', component: TablesStepsComponent, data: {id:'72c'},canActivate:[AuthGuard]},
          {path : 'step7-sub2-d)', component: TablesStepsComponent, data: {id:'72d'},canActivate:[AuthGuard]},
          {path : 'step7-sub2-e)', component: TablesStepsComponent, data: {id:'72e'},canActivate:[AuthGuard]},
          {path : 'step7-sub2-f)', component: TablesStepsComponent, data: {id:'72f'},canActivate:[AuthGuard]},
          {path : 'step7-sub2-g)', component: TablesStepsComponent, data: {id:'72g'},canActivate:[AuthGuard]},

          {path : 'step7-sub4-a)', component: TablesStepsComponent, data : {id:'74a'},canActivate: [AuthGuard] },
          {path : 'step7-sub4-b)', component: TablesStepsComponent, data : {id:'74b'},canActivate: [AuthGuard] },
          {path : 'step7-sub4-c)', component: TablesStepsComponent, data : {id:'74c'},canActivate: [AuthGuard] },
          {path : 'step7-sub4-d)', component: TablesStepsComponent, data : {id:'74d'},canActivate: [AuthGuard] },

          {path : 'step7-sub5' , component: TablesStepsComponent, data : {id : '75'},canActivate: [AuthGuard] },
          {path : 'step7-sub6' , component: TablesStepsComponent , data : {id : '76'},canActivate: [AuthGuard] },
          {path : 'step7-sub7' , component: TablesStepsComponent , data : {id : '77'},canActivate: [AuthGuard] },
          {path : 'step7-sub8' , component: TablesStepsComponent , data : {id : '78'},canActivate: [AuthGuard] },
          {path : 'step7-sub9' , component: TablesStepsComponent, data : {id : '79'},canActivate: [AuthGuard] },

          {path: 'step8', component: Norm35Step8Component, data: {id:'8'}, canActivate: [AuthGuard]},
          {path: 'step8-sub1', component: Step8DataComponent, data: {id:'81'},canActivate: [AuthGuard]},
          {path: 'step8-sub2', component: Step8DataComponent, data: {id:'82'},canActivate: [AuthGuard]},
          {path: 'step8-sub5', component: Step8DataComponent, data: {id:'85'},canActivate: [AuthGuard]},
          {path: 'step8-sub5', component: Step8DataComponent, data: {id:'5'},canActivate: [AuthGuard]},

          {path: 'step8-sub1-a)', component: TablesStepsComponent, data: {id: '81a', canActivate: [AuthGuard]}},
          {path: 'step8-sub1-b)', component: TablesStepsComponent, data: {id: '81b', canActivate: [AuthGuard]}},
          {path: 'step8-sub1-c)', component: TablesStepsComponent, data: {id: '81c', canActivate: [AuthGuard]}},
          {path: 'step8-sub3', component: TablesStepsComponent, data: {id: '83', canActivate: [AuthGuard]}},
          {path: 'step8-sub4', component: TablesStepsComponent, data: {id: '84', canActivate: [AuthGuard]}},
          {path: 'step8-sub5-a)', component: TablesStepsComponent, data: {id: '85a', canActivate: [AuthGuard]}},
          {path: 'step8-sub5-b)', component: TablesStepsComponent, data: {id: '85b', canActivate: [AuthGuard]}},
          {path: 'step8-sub5-c)', component: TablesStepsComponent, data: {id: '85c', canActivate: [AuthGuard]}},

          { path:  'step9-sub1' , component: TablesStepsComponent, data : {id : '91'},canActivate: [AuthGuard] },
          { path:  'step9-sub2' , component: TablesStepsComponent, data : {id : '92'},canActivate: [AuthGuard] },
          { path:  'step9-sub3' , component: TablesStepsComponent, data : {id : '93'},canActivate: [AuthGuard] },
          { path:  'step9-sub4' , component: TablesStepsComponent, data : {id : '94'},canActivate: [AuthGuard] },

          { path: 'aspectos-generales', component: Norm35Step10Component, data: {id: '10'},canActivate: [AuthGuard]},
          { path:  'step10-sub1' , component: TablesStepsComponent, data : {id : '101'},canActivate: [AuthGuard] },
          { path:  'step10-sub2' , component: TablesStepsComponent, data : {id : '102'},canActivate: [AuthGuard] },
          { path:  'step10-sub3' , component: TablesStepsComponent, data : {id : '103'},canActivate: [AuthGuard] },
          { path:  'step10-sub4' , component: TablesStepsComponent, data : {id : '104'},canActivate: [AuthGuard] },
          { path:  'step10-sub5' , component: TablesStepsComponent, data : {id : '105'},canActivate: [AuthGuard] },

          { path: 'gruia-verificacion-1', component: ListComponent, data : {id: '115'},canActivate: [AuthGuard]},
          { path: 'gruia-verificacion-2', component: ListComponent, data : {id: '116'},canActivate: [AuthGuard]},



      ]
  }
];

@NgModule({
  declarations: [
    DialogVideo,
    DialogTableVideo,
    VideoModal,
    MedicoDialog,



  ],
  imports     : [
      RouterModule.forChild(rutas),
      TranslateModule,
      MatBadgeModule,
      MatButtonModule,
      MatCheckboxModule,
      MatChipsModule,
      MatDatepickerModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatMenuModule,
      MatRippleModule,
      MatSelectModule,
      MatSnackBarModule,
      MatTableModule,
      MatToolbarModule,
      MatTabsModule,
      MatRadioModule,
      MatProgressBarModule,
      BrowserModule,
      BrowserAnimationsModule,
      DragDropModule,
      MatButtonToggleModule,
      MatCardModule,
      FuseSidebarModule,
      FuseSharedModule,
      FuseDemoModule,
      SweetAlert2Module,
      ExpedienteModule,

  ],
  entryComponents: [
    DialogVideo,
    VideoModal,
    DialogTableVideo,
    MedicoDialog,


  ]
})
export class WizardN35RutasModule {

}
